import { render, staticRenderFns } from "./ScoreEntry.vue?vue&type=template&id=1908e87a&scoped=true&"
import script from "./ScoreEntry.vue?vue&type=script&lang=js&"
export * from "./ScoreEntry.vue?vue&type=script&lang=js&"
import style0 from "./ScoreEntry.vue?vue&type=style&index=0&id=1908e87a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908e87a",
  null
  
)

export default component.exports